import billingReducer from '@sophocles/features/billing/slice';

export default billingReducer;
